module.exports = __webpack_public_path__ + "static/media/9.01ff4d55.jpg";